import Layout from '@/layout'

const villageRouter = {
  path: '/demand',
  component: Layout,
  children: [
    {
      path: '/grabbing',
      name: 'grabbing',
      meta: {
        title: '需求管理',
      },
      component: () => import('@/views/demand/grabbing.vue'),
    },
    {
      path: '/myGrabbing',
      name: 'myGrabbing',
      meta: {
        title: '我的需求',
      },
      component: () => import('@/views/demand/myGrabbing.vue'),
    },
    {
      path: '/authType',
      name: 'authType',
      meta: {
        title: '权限类型',
      },
      component: () => import('@/views/demand/authType.vue'),
    },
    {
      path: '/demandType',
      name: 'demandType',
      meta: {
        title: '需求类型',
      },
      component: () => import('@/views/demand/demandType.vue'),
    },
  ],
}

export default villageRouter
